
<div class="container">
	<app-rebate-claim-details *ngIf="rebate" [rebate]="rebate"></app-rebate-claim-details>
</div>